import { useExperiments } from '../experiments/experimentsQueries';
export const useHomeSearchVariant = () => {
  var _experiments$acad;
  const {
    experiments
  } = useExperiments();
  const group = experiments === null || experiments === void 0 || (_experiments$acad = experiments['acad-0009']) === null || _experiments$acad === void 0 ? void 0 : _experiments$acad.parameters.group;
  if (group === 'variationA' || group === 'variationB') {
    return group;
  }
  return 'control';
};